import { useEffect } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';

export const useResourcesPageAnalytics = () => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
	const { fireScreenEvent } = useFireAnalyticsEvents(identityAttrs);

	useEffect(() => {
		if (!identityAttrs) {
			return;
		}

		fireScreenEvent({
			name: sourceKey,
			attributes: identityAttrs,
		});
	}, [fireScreenEvent, identityAttrs, sourceKey]);
};
